module.exports = __webpack_public_path__ + "static/media/video-perspective-taking-es.fc5f160b.vtt";